import { Component, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';

import { SharedData, UserService } from '../../services/user.service';

import { ProgramSponsor } from '../../models/programsponsor';
import { ProgramSponsorDetailComponent } from '../program-sponsor-detail/program-sponsor-detail.component';
import { MatDialogRef, MatDialog } from '@angular/material/dialog';
import { ProgramSponsorCreateComponent } from '../program-sponsor-create/program-sponsor-create.component';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-program-sponsor',
    templateUrl: './program-sponsor.component.html',
    styleUrls: ['./program-sponsor.component.scss']
})
export class ProgramSponsorComponent implements OnInit {

    @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
    @ViewChild(MatSort, { static: true }) sort: MatSort;

    programSponsors = [];
    displayedColumns: string[] = ['ProgramSponsorId', 'ProgramSponsorDescription','CompassUri','CompassAuthorization', 'ProgramSponsorActive', 'CreatedDate', 'ModifiedBy', 'edit'];
    dataSource = new MatTableDataSource<ProgramSponsor>();
    dialogRef: MatDialogRef<ProgramSponsorDetailComponent>;
    searching = true;
    searchValue = '';
    isCustomUiChange: boolean = false;
    private sharedDataSubscription: Subscription;

    constructor(private userService: UserService, private dialog: MatDialog) {
        this.sharedDataSubscription = this.userService.sharedData$.subscribe((data: SharedData) => {
            this.isCustomUiChange = data.isCustomUiChange;
        });
    }

    ngOnInit(): void {
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;

        // Custom filter for global search
        this.dataSource.filterPredicate = (data: ProgramSponsor, filter: string) => {
        const dataStr = Object.keys(data).map(key => {
            const value = data[key];
            return value ? value.toString().toLowerCase() : '';
        }).join(' ');
        return dataStr.includes(filter);
        };
        this.getProgramSponsors();
    }

    ngOnDestroy(): void {
        this.sharedDataSubscription.unsubscribe();
    }

    applyFilter() {
        this.dataSource.filter = this.searchValue.trim().toLowerCase();
    }

    clearSearch() {
      this.searchValue = '';
      this.applyFilter();
    }

    private getProgramSponsors() {
        this.userService.getProgramSponsors().subscribe(data => {
            this.programSponsors = data;
            this.dataSource.data = this.programSponsors;
            this.searching = false;
        });
    }

    addNewPSponsor() {
        let className = localStorage.getItem("themeName");
        const dialogCreate = this.dialog.open(ProgramSponsorCreateComponent, { 
            panelClass: className,
            data: { 
                isCustomUiChange: this.isCustomUiChange
            },
            disableClose: true
        });
        dialogCreate.afterClosed().subscribe(result => {
            this.getProgramSponsors();
        });
    }

    public handleClick(programSponsor: ProgramSponsor) {
        /*   this.router.navigate(['/programSponsorDetail']); */
        let className=localStorage.getItem("themeName");
        this.dialogRef = this.dialog.open(ProgramSponsorDetailComponent,
            {
                data: {
                    dataKey: programSponsor
                },panelClass:className
            });

        this.dialogRef.afterClosed().subscribe(result => {
            this.getProgramSponsors();
        });
    }
}
